import { useEffect, useState } from "react";
import { useDataProvider, useNotify } from "react-admin";
import { useMutation } from "react-query";
import { useFormContext } from "react-hook-form";
import { addDaysToDateOnly, addMonthsToDateOnly } from "../../utils/timezone";

const useLastPeriodRange = (firstDate, lastDate) => {
  const [startDate, setStartDate] = useState(firstDate);
  const [endDate, setEndDate] = useState(lastDate);

  const { getValues } = useFormContext() ?? {};
  const dataProvider = useDataProvider();
  const notify = useNotify();

  const { data, mutate, error, isError, isSuccess } = useMutation(() =>
    dataProvider.getListNoParams("restock-plans/last-period-range")
  );

  useEffect(() => {
    if (isError) {
      if (typeof error === "string") {
        notify(error, { type: "error" });
      } else {
        notify("invalid return value of /last-period-range", { type: "error" });
      }
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess && (data || data === 0)) {
      const cut_off_date = getValues("cut_off_date");
      if (cut_off_date) {
        setStartDate(addMonthsToDateOnly(cut_off_date, +data));
        setEndDate(addDaysToDateOnly(cut_off_date, 60));
      }
    }
  }, [data, isSuccess]);

  useEffect(() => {
    if (getValues) {
      const cut_off_date = getValues("cut_off_date");
      if (cut_off_date) {
        mutate();
      }
    }
  }, []);

  return [startDate, endDate];
};

export default useLastPeriodRange;
